<div class="fdx-c-notification" [ngClass]="{
        'fdx-c-notification--default': (
            notificationType !=='FULL_INLINE_ERROR' && notificationType!=='INLINE_ERROR' && notificationType !=='BLOCK_TOAST_ERROR'
        ),
        'fdx-c-notification--full-width': (notificationType==='FULL_INLINE' ||notificationType==='FULL_INLINE_ERROR'),
        'fdx-c-notification--responsive-inline': (notificationType==='FULL_INLINE' || notificationType==='FULL_INLINE_ERROR'),
        'fdx-c-notification--block':(notificationType==='BLOCK' || notificationType==='BLOCK_TOAST'|| notificationType==='BLOCK_ERROR'),
        'fdx-c-notification--inline':(notificationType==='INLINE'|| notificationType==='INLINE_ERROR'),        
        'fdx-c-notification--toast': (notificationType==='BLOCK_TOAST' || notificationType==='BLOCK_TOAST_ERROR'),
        'fdx-c-notification--error': (notificationType==='FULL_INLINE_ERROR' || notificationType==='BLOCK_ERROR' || notificationType==='BLOCK_TOAST_ERROR' ||notificationType==='INLINE_ERROR')
      }">
    <div class="fdx-c-notification__main  my-auto">
        <div class="fdx-c-notification__header">
            <svg class="fdx-c-icon" aria-hidden="true">
                <use xlink:href="#exclamation-triangle"></use>
            </svg>
        </div>
        <div class="fdx-c-notification__body">
            <h3 class="fdx-c-notification__title" *ngIf="notificationTitle!==undefined && notificationTitle.length!==0">
                {{notificationTitle}}</h3>

            <div class="col-12" *ngIf="!displayStayButton && !displayLeaveButton && !viewButton">

                <div *ngIf="notificationBodyArray!=null && notificationBodyArray.length > 0 ; else displayBody">
                    <div *ngFor="let notification of notificationBodyArray; let num = index">
                        {{notification}}
                    </div>
                </div>

                <ng-template #displayBody>
                    <div class="fdx-c-notification__description"
                        *ngIf="notificationBodyContent!==undefined && notificationBodyContent.length!==0">
                        {{notificationBodyContent}}
                    </div>
                </ng-template>
            </div>


            <div class="row my-auto">

                <div class="col-8" *ngIf="displayStayButton || displayLeaveButton || viewButton">

                    <div *ngIf="notificationBodyArray!=null && notificationBodyArray.length > 0 ; else displayBody">
                        <div *ngFor="let notification of notificationBodyArray; let num = index">
                            {{notification}}
                        </div>
                    </div>

                    <ng-template #displayBody>
                        <div class="fdx-c-notification__description"
                            *ngIf="notificationBodyContent!==undefined && notificationBodyContent.length!==0">
                            {{notificationBodyContent}}
                        </div>
                    </ng-template>
                </div>


                <div class="col-4" *ngIf="displayStayButton || displayLeaveButton || viewButton">
                    <div class="fxg-button--float-right">

                        <a (click)="raiseNotificationEvent('leave')" *ngIf="displayLeaveButton"
                            class="fdx-c-button fdx-c-button--primary-outline fxg-margin-right">
                            {{"COMMON.CommonModaldialogButton_Leavepage" | translate: {Default: "LEAVE PAGE"} }}
                        </a>

                        <a (click)="raiseNotificationEvent('stay')" *ngIf="displayStayButton"
                            class="fdx-c-button fdx-c-button--primary fxg-margin-right">
                            {{"COMMON.CommonModaldialogButton_Stay" | translate: {Default: "STAY"} }}
                        </a>

                        <a (click)="raiseNotificationEvent('view')" *ngIf="viewButton"
                            class="fdx-c-button fdx-c-button--tertiary fxg-margin-right">
                            {{"COMMON.CommonModaldialogButton_View" | translate: {Default: "VIEW"} }}
                        </a>

                    </div>
                </div>
            </div>
        </div>
        <div class="fdx-c-notification__footer">
            <button class="fdx-c-button fdx-c-button--icon" aria-label="close notification message"
                (click)="raiseNotificationEvent('close')" *ngIf="dislayCloseButton">
                <svg class="fdx-c-icon" aria-hidden="true">
                    <use href="#cross"></use>
                </svg>
            </button>
        </div>
    </div>
</div>